<div class="row">
    @for (eventAlarm of eventAlarms; track $index) {
        <div class="col-sm-12 col-md-6 col-lg-4 pb-3">
            <div class="card mb-3">
                <div
                    class="card-title tile-header me-0 ps-3"
                    style="display: grid; grid-template-columns: 1fr 50px">
                    <h3 class="d-inline-block w-100 me-0 pt-2 text-break pe-2">
                        {{
                            eventAlarm.alarmName || ('common_Untitled' | translate) | slice: 0 : 200
                        }}
                    </h3>
                    <div class="p-1 float-end" style="width: fit-content">
                        <div ngbDropdown placement="bottom-right">
                            <button
                                class="btn btn-link"
                                id="dropdownMeterActions"
                                ngbDropdownToggle
                                style="float: right">
                                <i class="bi bi-three-dots-vertical"></i>
                            </button>
                            <div ngbDropdownMenu>
                                <button
                                    ngbDropdownItem
                                    (click)="editAlarm.emit(eventAlarm.subscriptionId)">
                                    {{ 'common_Edit' | translate }}
                                </button>
                                <button
                                    ngbDropdownItem
                                    (click)="duplicateAlarm.emit(eventAlarm.subscriptionId)">
                                    {{ 'monitoring_duplicate' | translate }}
                                </button>
                                <button ngbDropdownItem (click)="deleteEventAlarm.emit(eventAlarm)">
                                    {{ 'common_Delete' | translate }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-body">
                    @if (eventAlarm.meterModelCriteriaMismatch) {
                        <div class="m-0 text-warning">
                            <i class="bi bi-exclamation-circle-fill"></i>
                            {{ 'event-alarms_unsupportedEventTypeMsg' | translate }}
                        </div>
                    } @else {
                        <div class="m-0 text-success">
                            <i class="bi bi-check-circle-fill"></i>
                            {{ 'common_All_connected_devices_supported' | translate }}
                        </div>
                    }
                    <ul class="list-group list-group-flush description-list w-100">
                        <li class="list-group-item">
                            <span>{{ 'event-alarms_EventType' | translate }}</span>
                            <span class="text-nowrap">
                                {{ eventAlarm.eventTypeId | eventAlarm }}
                            </span>
                        </li>
                        <li class="list-group-item text-nowrap">
                            <div>{{ 'onlineReportingCostMail_type' | translate }}</div>
                            @if (eventAlarm.vendorModels.length === 1) {
                                {{
                                    'mappers_meterType.' + eventAlarm.vendorModels[0].meterType
                                        | translate: 'online' : 'common'
                                }}
                                - {{ eventAlarm.vendorModels[0].modelName }}
                            } @else if (eventAlarm.vendorModels.length > 1) {
                                {{ 'event-alarms_multiple_meter-sensor-types' | translate }}
                            }
                        </li>
                    </ul>

                    <div class="text-end">
                        <button
                            (click)="editAlarm.emit(eventAlarm.subscriptionId)"
                            class="btn btn-link">
                            {{ 'common_Edit' | translate }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    } @empty {
        <div class="col-12">
            <div class="alert alert-warning text-center m-3" role="alert">
                {{
                    ('table_NO_DATA_FROM_SOURCE' | translate: 'online' : 'common')
                        .replace('{0}', 'event-alarms_event_alarms' | translate)
                        .replace('{1}', 'event-alarms_create-event-alarm' | translate)
                }}
            </div>
        </div>
    }
</div>
